import { useState } from "react";
import { useDispatch } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataPDF } from "../utils/fetchData";
import Footer from "./footer";
import Navbar from "./navbar";

export default function Verify() {
	const dispatch = useDispatch();

	const [cerificateId, setCertificateId] = useState("");
	const [errors, setErrors] = useState({});

	const validateForm = () => {
		const newErrors = {};
		if (!cerificateId) {
			newErrors.name = "Certificate ID is required.";
		} else if (cerificateId.length !== 16) {
			newErrors.name = "Enter valid Certificate ID";
		}
		setErrors(newErrors);
		// console.log("newErrors", newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		console.log("file", cerificateId);
		var newfile = {
			file: "certificates/" + cerificateId + ".pdf",
		};
		// pdfWindow.location.href = file;
		// getDataPDF(`getCoursePdf`, newfile).then((res, err) => {
		// 	console.log("res", res);
		// 	// const pdfWindow = window.open();
		// 	if (res.status === 404) {
		// 		console.log("err", err);
		// 		alert("No certificate is found with the entered certificate ID");
		// 		return;
		// 	}
		// 	console.log("res my courses 11 ", res.data);

		// 	const newfile1 = new Blob([res.data], { type: "application/pdf" });
		// 	//Build a URL from the file
		// 	const fileURL = URL.createObjectURL(newfile1);
		// 	//Open the URL on new Window
		// 	// setPdfFile(fileURL);
		// 	// pdfWindow.location.href = fileURL;
		// 	window.open(fileURL, "_blank");
		// 	dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
		// 	// window.open(fileURL);
		// });
		getDataPDF("getCoursePdf", newfile)
			.then((res) => {
				if (res.status === 404) {
					alert("No certificate is found with the entered certificate ID.");
					return;
				}

				const newfile1 = new Blob([res.data], { type: "application/pdf" });
				const fileURL = URL.createObjectURL(newfile1);
				window.open(fileURL, "_blank");

				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			})
			.catch((err) => {
				console.error("PDF Download Error:", err);
				alert("No certificate is found with the entered certificate ID.");
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			});
	};

	return (
		<>
			<Navbar />
			<div style={{ backgroundColor: "white" }}>
				<div className="spacer"></div>
				<div id="testlogin">
					<div className="row">
						<div className="col-1"></div>
						<div className="col-10 block">
							<form onSubmit={handleSubmit}>
								<div className="row">
									<label className="email-label">Certificate ID</label>
									<div className="email-input">
										<input
											className="email-input"
											type="text"
											onChange={(e) => setCertificateId(e.target.value)}
											value={cerificateId}
											name="certificate"
											autoComplete="off"
										/>
									</div>
									<p
										style={{
											visibility: errors.name ? "visible" : "hidden",
										}}
										className="error-message ms-3">
										{errors.name}
									</p>
								</div>

								<button className="login-button mt-3" type="submit">
									Submit
								</button>
							</form>
						</div>

						<div className="col-1"></div>
					</div>
				</div>
				<div className="spacer"></div>
			</div>
			<Footer />
		</>
	);
}
